import { Col, Row, Form, Input, Button } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import FancyVideo from "react-videojs-fancybox";

const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent9 = () => {
  return (
    <>
      <section className="py-4">
        <Row justify={"center"}>
          <Col lg={18}>
            <Row justify="center" className="items-center">
              <Col xxl={24} md={24} sm={23} xs={23}>
                <FancyVideo
                  source="https://devu1a.customdev.solutions/BadalGazi/wp-content/uploads/2024/09/Badal-Gazi_Render_Rev-01-1727130637.mp4"
                  poster={ImageUrl("videobg.png")} // Corrected poster attribute
                  id={"sintel"}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent9;
